/** No React state in parents — context set before open, banner toggles display via refs. */

export type DirectorCrossSuggestBannerContext = {
  message: string;
  onApply: () => void;
};

let currentContext: DirectorCrossSuggestBannerContext | null = null;

export const DIRECTOR_CROSS_SUGGEST_BANNER_OPEN_EVENT = 'directorCrossSuggestBanner:open';
export const DIRECTOR_CROSS_SUGGEST_BANNER_CLOSE_EVENT = 'directorCrossSuggestBanner:close';

export function setDirectorCrossSuggestBannerContext(ctx: DirectorCrossSuggestBannerContext): void {
  currentContext = ctx;
}

export function getDirectorCrossSuggestBannerContext(): DirectorCrossSuggestBannerContext | null {
  return currentContext;
}

export function openDirectorCrossSuggestBanner(): void {
  document.dispatchEvent(new CustomEvent(DIRECTOR_CROSS_SUGGEST_BANNER_OPEN_EVENT));
}

export function closeDirectorCrossSuggestBanner(): void {
  document.dispatchEvent(new CustomEvent(DIRECTOR_CROSS_SUGGEST_BANNER_CLOSE_EVENT));
}
